import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_poi_chart.svg';
import SVG from "react-inlinesvg";

const IconPoiChart = () => (

    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />

);
export default IconPoiChart;